import { render, staticRenderFns } from "./termination.vue?vue&type=template&id=115087f7&scoped=true&"
import script from "./termination.vue?vue&type=script&lang=js&"
export * from "./termination.vue?vue&type=script&lang=js&"
import style0 from "./termination.vue?vue&type=style&index=0&id=115087f7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115087f7",
  null
  
)

export default component.exports